import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserDomainService } from '@app/auth/domain/user-domain.service';

/**
 * Keeps members who have already completed onboarding out of the flow when they deeplink into it;
 * otherwise the mistake only surfaces as a 400 on submit.
 *
 * Synchronous: `authInitializerProvider` blocks bootstrap on `users/me/`, so `user$$` is always
 * populated by the time a navigation is evaluated. It runs on entry only, so finishing onboarding
 * does not evict the member from the success screen. No user means no access.
 */
export const onboardingGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userDomainService = inject(UserDomainService);

  if (userDomainService.user$$()?.hasToShowOnboarding) {
    return true;
  }

  return router.parseUrl('/members-area');
};
